import { countries } from 'countries-list';

export const countryOptions = Object.values(countries)
  .map((country) => country.name)
  .sort((left, right) => left.localeCompare(right));
